import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import client from './client';
import type { FeedbackDto, FeedbackPatternDto } from '../types/api';

export const feedbackKeys = {
  all:      () => ['feedback']          as const,
  list:     () => ['feedback', 'list']  as const,
  patterns: () => ['feedback', 'patterns'] as const,
};

export function useFeedbackList() {
  return useQuery({
    queryKey: feedbackKeys.list(),
    queryFn: () => client.get<FeedbackDto[]>('/feedback').then((r) => r.data),
  });
}

export function useFeedbackPatterns() {
  return useQuery({
    queryKey: feedbackKeys.patterns(),
    queryFn: () => client.get<FeedbackPatternDto[]>('/feedback/patterns').then((r) => r.data),
  });
}

export function useSubmitFeedback() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { text: string; taskId?: string }) =>
      client.post<FeedbackDto>('/feedback', body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: feedbackKeys.all() }),
  });
}

export function useDeleteFeedback() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => client.delete(`/feedback/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: feedbackKeys.all() }),
  });
}
